import './Available.css'
const Available = () => (
    <div>
        <div className="availer"></div>
        <span className="avail">Next Availability</span><br/>
        <span className="avail">At 6:30 PM</span><span className="now"><a href="https://www.shf.com">SCHEDULE NOW</a></span>
    </div>
);

export default Available;